export default __webpack_public_path__ + "static/Nourish_the_Nation_Stroke--desktop-ad72057a027f27cc04d53f170ad88e6e.jpg";